import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as navegacaoActions from './actions/navegacaoActions'
import $ from 'jquery';
import { Link } from 'react-router';
import ConfigD from './util/ConfigD';
import ImagemHost from './ImagemHost'
import MenuDenuncia from './MenuDenuncia'
import MenuInicio from './MenuInicio'

 
//Links para o sistema:
//link default que o próprio sistema irá montar se vier para a index vazia: http://localhost:3000/cadastrarProtocolo/portal/ouvidoria/geral
//link default que o próprio sistema irá montar se vier para a index vazia página denúncia: http://localhost:3000/cadastrarProtocolo/portal/ouvidoria/denuncia
//link cadastro ouvidoria natureza geral e uf: http://localhost:3000/cadastrarProtocolo/portal/ouvidoria/geral/na
//link cadastro sac natureza geral e uf: http://localhost:3000/cadastrarProtocolo/totem/sac/geral/na
//link cadastro sac natureza denúncia e uf: http://localhost:3000/cadastrarProtocolo/intranet/sac/geral/na
//link cadastro ouvidoria natureza denúncia e uf: http://localhost:3000/cadastrarProtocolo/sac/ouvidoria/geral/na


class Header extends React.Component {

    constructor(props, context) {
        super(props, context);

      }


    render() {
      var linkCadastro = '/portal/ouvidoria/geral/';
      var linkCadastrodenuncia = '/portal/ouvidoria/denuncia';

      if(!$.isEmptyObject(this.props.navegacao)){
        linkCadastro = '/' + this.props.navegacao.canal + '/' + this.props.navegacao.grupoTratamento + '/'+ this.props.navegacao.natureza+'/'+ this.props.navegacao.uf;
        linkCadastrodenuncia = '/' + this.props.navegacao.canal + '/ouvidoria/denuncia';
        //console.log('linkCadastro', linkCadastro);
        //console.log('linkCadastrodenuncia', linkCadastrodenuncia);
     }
    return (
			<div>
           <header id="header">
              <div className="main-header">
              
                 <div className="container">
                     <div className="logo pull-left">
                       <h1>
                         <Link to={ConfigD.getServerBase() + '/'}>
                           <ImagemHost />
                         </Link>
                       </h1>
                    </div>
                    <div className="mobile navbar-header">
                       <a className="navbar-toggle" data-toggle="collapse" href=".navbar-collapse">
                       <i className="fa fa-bars fa-2x"></i>
                       </a> 
                    </div>
                    <nav className="collapse navbar-collapse menu">
                       <ul className="nav navbar-nav sf-menu">
                          <MenuInicio linkCadastro={linkCadastro} />
                          <li>
                            <Link to={ConfigD.getServerBase() + '/cadastrarProtocolo' + linkCadastro} className="sf-with-ul">
                              Registrar 
                             </Link>
                            <ul>
                              <li><Link to={ConfigD.getServerBase() + '/cadastrarProtocolo'+linkCadastro} className="sf-with-ul"> Reclamação, sugestão ou elogio</Link></li>
                              <MenuDenuncia linkCadastrodenuncia={linkCadastrodenuncia} canal={!$.isEmptyObject(this.props.navegacao) ? this.props.navegacao.canal : ''} />
                            </ul>
                          </li>
                          <li>
                            <Link to={ConfigD.getServerBase() + '/consultarProtocolo'} className="sf-with-ul">
                             Consultar
                             </Link>
                          </li>
                          <li>
                            <Link to={ConfigD.getServerBase() + '/dashboard'} className="sf-with-ul">
                             Estatísticas
                             </Link>
                          </li>
                       </ul>
                       
                    </nav>
                 </div>
              </div>
 
           </header>
           
			</div>

    );
  }
}


           
Header.protoType = {
  //actionCliente: PropTypes.object.isRequired
  actions: PropTypes.object.isRequired

}
Header.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
  
  return {
      navegacao: state.navegacao
  };
}

export default connect(mapStateToProps, null)(Header);


/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/